import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { SubscriptionsDetailsDemo } from '../../../../data';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { handleGetSubscriptionsDetailsOpe } from './SubscriptionsDetailsOpe';

const SubscriptionsDetailsContext = createContext();

export const useSubscriptionsDetails = () => useContext(SubscriptionsDetailsContext);

function SubscriptionsDetailsProvider({ subscriptionId, children }) {
    const [subscriptionsDetailsData, setSubscriptionsDetailsData] =
        useState(SubscriptionsDetailsDemo);
    const [reloadKey, setReloadKey] = useState(0);
    const [featureEditModal, setFeatureEditModal] = useState({
        show: false,
        data: ''
    });
    const [openGithubReleasesView, setOpenGithubReleasesView] = useState({
        show: false,
        data: ''
    });
    // -- Link with Github modal control
    const [openLinkWithGithubModal, setOpenLinkWithGithubModal] = useState({
        show: false,
        Search: ''
    });
    const [openModifyVersionModal, setOpenModifyVersionModal] = useState(false);
    // --Modal open handler
    const [showModal, setShowModal] = useState({ type: '', data: null });
    const { setMessage } = useTemplate();
    // -- Load all customer initially
    useEffect(() => {
        setSubscriptionsDetailsData(SubscriptionsDetailsDemo);
        handleGetSubscriptionsDetailsOpe(subscriptionId)
            .then(({ data }) => {
                setSubscriptionsDetailsData(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.toString(0) });
                setSubscriptionsDetailsData({});
            });
    }, [subscriptionId, setMessage, reloadKey]);

    const value = useMemo(() => {
        // Reload key is used to reload the data
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        // --Handler to open modal
        const openModal = (type, data) => {
            setShowModal({
                type,
                data
            });
        };
        // --Handler to close modal
        const closeModal = () => {
            setShowModal({
                type: '',
                data: null
            });
        };

        // Features Edit Modal Open Handler
        const handleFeatureEditModal = (data) => {
            setFeatureEditModal({ show: true, data });
        };
        // Features Edit Modal Open Handler
        const closeFeatureEditModal = () => {
            setFeatureEditModal({ show: false, data: null });
        };

        return {
            subscriptionsDetailsData,
            setSubscriptionsDetailsData,
            reloadKey,
            setReloadKey,
            handleReload,

            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data,

            // Features Edit modal
            featureEditModal,
            setFeatureEditModal,
            handleFeatureEditModal,
            closeFeatureEditModal,
            // -- Link with Github modal control
            openLinkWithGithubModal,
            setOpenLinkWithGithubModal,
            // -- Github Releases View
            openGithubReleasesView,
            setOpenGithubReleasesView,
            openModifyVersionModal,
            setOpenModifyVersionModal
        };
    }, [
        subscriptionsDetailsData,
        reloadKey,
        showModal?.type,
        showModal?.data,
        featureEditModal,
        openLinkWithGithubModal,
        openGithubReleasesView,
        openModifyVersionModal
    ]);

    return (
        <SubscriptionsDetailsContext.Provider value={value}>
            {children}
        </SubscriptionsDetailsContext.Provider>
    );
}

export default SubscriptionsDetailsProvider;
